import { useState, useMemo } from 'react'
import { mergeDocuments } from '../utils/documentUtils.js'
import { useGetRequestTaskQuery } from '../../../config/api/requestTask/requestTask.js'

/**
 * Custom hook for managing document state and operations
 */
export const useDocumentManagement = (requestTemplate, requestTaskId) => {
  const [dragOverDocId, setDragOverDocId] = useState(null)

  const { data, error, isLoading, isError, refetch } = useGetRequestTaskQuery(
    String(requestTaskId),
    {
      skip: !requestTaskId,
    },
  )

  const documents = useMemo(() => {
    if (!requestTemplate || !data?.requestTask) {
      return []
    }

    return mergeDocuments(requestTemplate, data.requestTask)
  }, [requestTemplate, data])

  const unmatchedFiles = useMemo(() => {
    return data?.requestTask.unmatched_files || []
  }, [data])

  return {
    requestTask: data?.requestTask,
    documents,
    unmatchedFiles,
    dragOverDocId,
    setDragOverDocId,
    isLoading,
    isError,
    error,
    refetch,
  }
}
